import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from '@helpers/helper';
import { AudienciaDto } from '@models/audiencia/audienciaDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CreateCedulaNotificacionRequest } from '@models/documento/createCedulaNotificacionRequest.model';
import { DeleteExpedienteRequest } from '@models/expediente/deleteExpedienteRequest.model';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { PericiaDto } from '@models/pericia/periciaDto.model';
import { SharedModule } from '@modules/shared.module';
import { AudienciaService } from '@services/audiencia/audiencia.service';
import { DocumentoService } from '@services/documento/documento.service';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { PericiaService } from '@services/pericia/pericia.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogAccionesDocumentoComponent } from '@views/documentos/dialog-acciones-documento/dialog-acciones-documento.component';
import { DialogCreateCedulaNotificacionComponent } from '@views/documentos/generarArchivos/dialog-create-cedula-notificacion/dialog-create-cedula-notificacion.component';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HistorialExpedienteService } from '@services/historialExpediente/historialExpediente.service';
import { HistorialExpedienteComponent } from '../historial-expediente/historial-expediente.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonActionComponent } from 'src/app/component/button-action/button-action.component';
import { ButtonExportFileComponent } from 'src/app/component/button-export-file/button-export-file.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';
import { GeneralCalendarComponent } from '@component/general-calendar/general-calendar-list/general-calendar.component';
import { ListRegistroContableComponent } from '@views/registros-contable/list-registro-contable/list-registro-contable.component';
import { ListExpedienteNotaComponent } from '@views/expedientesNotas/list-expediente-nota/list-expediente-nota.component';
import { ListTareaComponent } from '@views/tareas/list-tarea/list-tarea.component';
import { ListMovimientoExpedienteComponent } from '@views/movimientos-expediente/list-movimiento-expediente/list-movimiento-expediente.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FormExpedientePartesComponent } from '../form-expediente-partes/form-expediente-partes.component';
import { ListAudienciaComponent } from '@views/audiencias/list-audiencia/list-audiencia.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { DialogFormAuditoriaComponent } from '@views/audiencias/dialog-form-auditoria/dialog-form-auditoria.component';
import { PruebasExpedienteComponent } from '@views/pruebas/pruebaExpediente/pruebas-expediente/pruebas-expediente.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ExpedienteVinculadoService } from '@services/expedienteVinculado/expedienteVinculado.service';
import { ExpedienteVinculadoDto } from '@models/expedienteVinculado/expedienteVinculadoDto.model';
import { CardExpedienteVinculadoComponent } from '@views/expediente-vinculado/card-expediente-vinculado/card-expediente-vinculado.component';
import { MatListModule } from '@angular/material/list';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: true,
  imports: [AppRolesDirective, MatFormFieldModule, MatInputModule, MatCardModule, MatTabsModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, CommonModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, GoBackAndTitleComponent, GeneralCalendarComponent, ListRegistroContableComponent, FormExpedientePartesComponent, ListExpedienteNotaComponent, ListTareaComponent, ListAudienciaComponent, ListMovimientoExpedienteComponent, PruebasExpedienteComponent, MatToolbarModule, MatListModule, CardExpedienteVinculadoComponent],
  selector: 'app-form-expediente-view',
  templateUrl: './form-expediente-view.component.html',
  styleUrls: ['./form-expediente-view.component.css'],
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class FormExpedienteViewComponent {
  // Variable que almacena el índice del tab seleccionado
  selectedIndex!: number;
  expedienteDto!: ExpedienteDto;
  audiencias!: AudienciaDto[];
  pericias!: PericiaDto[];
  private destroy$ = new Subject<void>();


  dataSourcePericias = new MatTableDataSource<PericiaDto>();

  dataSourceAudiencia = new MatTableDataSource<AudienciaDto>();
  displayedColumnsAudiencias: string[] = ['lugar', 'sala', 'fecha', 'tipoAudiencia', 'accion'];
  idExpediente!: number;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private expedienteService: ExpedienteService,
    private snackBar: SnackBarService,
    private audienciaService: AudienciaService,
    private periciasService: PericiaService,
    private breakpointObserver: BreakpointObserver,
    private documentoService: DocumentoService,
    private historialExpedienteService: HistorialExpedienteService,
    private expedienteVinculadoService: ExpedienteVinculadoService

  ) {
  }

  ngOnInit(): void {
    const storedIndex = localStorage.getItem('selectedTabIndex');
    this.selectedIndex = storedIndex ? +storedIndex : 0;

    const id = this.activatedRoute.snapshot.params['id'];
    if (!id || isNaN(+id)) {
      this.snackBar.showError('ID de expediente inválido', 'Error');
      this.router.navigate(['/expedientes']);
      return;
    }

    this.idExpediente = +id;
    this.getExpedienteById(this.idExpediente);
  }

  // Método que se ejecuta cuando se cambia el tab
  onTabChange(): void {
    // Guardamos el índice del tab seleccionado en localStorage
    localStorage.setItem('selectedTabIndex', this.selectedIndex.toString());
  }
  getExpedienteById(id: number) {
    this.spinner.show("spExpediente")
    this.expedienteService.getById(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.spinner.hide("spExpediente")
          this.expedienteDto = data
          this.expedienteService.setExpedienteDto(data)
        },
        error => {
          this.spinner.hide("spExpediente")
          this.snackBar.showError(error, "Error");
        })
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAudienciaByIdExpediente(id: number) {
    this.spinner.show("spAudiencias")
    this.audienciaService.getAllByIdExpediente(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.spinner.hide("spAudiencias")
          this.audiencias = data
          this.dataSourceAudiencia.data = data
        },
        error => {
          this.spinner.hide("spAudiencias")
          this.snackBar.showError(error, "Error");
        })
  }

  verHistorialExpediente(expedienteDto: ExpedienteDto) {
    this.spinner.show("spExpediente")
    this.historialExpedienteService.getAllByIdExpediente(expedienteDto.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.spinner.hide("spExpediente")

          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = "80%"
          dialogConfig.autoFocus = false;
          dialogConfig.data = data

          const dialogRef = this.dialog.open(HistorialExpedienteComponent, dialogConfig);

          dialogRef.afterClosed().subscribe(result => {

          });
        },
        error => {
          this.spinner.hide("spExpediente")
          this.snackBar.showError(error, "Error");
        })
  }

  getPericiasByIdExpediente(id: number) {
    this.spinner.show("spPericias")
    this.periciasService.getAllByIdExpediente(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.spinner.hide("spPericias")
          this.pericias = data
          this.dataSourcePericias.data = data
        },
        error => {
          this.spinner.hide("spPericias")
          this.snackBar.showError(error, "Error");
        })
  }





  onNuevaAudiencia(): void {
    const dialogRef = this.dialog.open(DialogFormAuditoriaComponent, {
      data: { event: AccionesDialog.Agregar, idExpediente: this.idExpediente },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.getAudienciaByIdExpediente(this.idExpediente)
    });
  }

  openDialogDelete(obj: any) {
    obj.descripcion = obj.caratula
    obj.id = obj.id
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "50%",
      dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogDeleteComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data) {
        this.deleteRowData(result.data);
      }
    });
  }

  deleteRowData(id: number) {
    let deleteExpedienteRequest = new DeleteExpedienteRequest
    deleteExpedienteRequest.id = id
    this.spinner.show('spExpediente')
    this.expedienteService.deleteExpediente(deleteExpedienteRequest)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.spinner.hide('spExpediente')
          this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
          this.router.navigate(["/expedientes"])
        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        });
  }

  copiarAlPortapapeles(texto: string) {
    Helper.copyToClipboard(texto)
  }

  generarCedulaNotificacion(expedienteDto: ExpedienteDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = expedienteDto

    const dialogRef = this.dialog.open(DialogCreateCedulaNotificacionComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {

      const dialogConfig2 = new MatDialogConfig();
      dialogConfig2.autoFocus = false;
      dialogConfig2.data = result
      dialogConfig2.width = '500px'

      const dialogRef2 = this.dialog.open(DialogAccionesDocumentoComponent, dialogConfig2);

      dialogRef2.afterClosed().subscribe(result2 => {

        dialogRef.close()

      });
    });
  }
}
